import { cn } from "../lib/cn";

export interface SpinnerProps {
  className?: string;
  /** Announced to assistive technology; keep it specific ("Loading claims"). */
  label: string;
  size?: 4 | 5 | 6;
}

/**
 * doc 27 §8 prefers skeletons for known layouts; a spinner is for an action in
 * flight (a button submitting), where the layout is not what is loading.
 */
export function Spinner({ className, label, size = 4 }: SpinnerProps) {
  return (
    <span role="status" aria-live="polite" className={cn("inline-flex", className)}>
      <svg
        className={cn(size === 4 ? "h-4 w-4" : size === 5 ? "h-5 w-5" : "h-6 w-6", "animate-spin")}
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden="true"
      >
        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeOpacity="0.25" strokeWidth="1.5" />
        <path
          d="M21 12a9 9 0 0 0-9-9"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
      <span className="sr-only">{label}</span>
    </span>
  );
}
